export class FontSize {
    constructor(public name: string, public size: string){
        this.dimensions = {};
    }

    public dimensions: {[key: string]: number};
}



// WEBPACK FOOTER //
// ./src/app/shared/models/font-size.ts